import { useContext } from 'react';
import { Flex, Box, Avatar, Text, Paper } from '@mantine/core';

import AuthContext from 'context/AuthContext';
import { formatPhoneNumber } from 'utils/phone';

import classes from './UserButton.module.scss';

const UserButton = () => {
  const {
    data: { company },
  } = useContext(AuthContext);
  const name = company?.name || '';

  return (
    <Box>
      <Paper
        py="sm"
        radius="md"
        withBorder
        style={{ display: 'flex', justifyContent: 'flex-start' }}
      >
        <Flex
          px="md"
          gap={9}
          direction="column"
          className={classes.userButton}
          style={{ alignSelf: 'center' }}
        >
          <Flex direction="column" gap={0}>
            <Text span fz="0.75rem">
              Your Nucleus number
            </Text>
            <Text span fz="1.25rem" fw={700} lh={1}>
              {formatPhoneNumber(company?.did || '', false)}
            </Text>
          </Flex>
          <Flex gap="sm" align="center">
            <Avatar
              variant="filled"
              size="1.4rem"
              name={name}
              color="var(--primary-color)"
              styles={{
                placeholder: {
                  fontSize: '0.9rem',
                },
              }}
            >
              {name[0]}
            </Avatar>
            <Text fz="sm">{name || 'Unnamed'}</Text>
          </Flex>
        </Flex>
      </Paper>
    </Box>
  );
};

export default UserButton;
